<template>
  <section class="container-fluid p-0 bodyArea">
    <div class="containerBox">
      <div class="pageHeader row align-items-center">
        <div class="col-3 pageHeaderTitle">Tenant Auth Connections</div>
        <div class="col text-right">
          <div class="filterWrapper">
            <div class="filterText">Tenant :</div>
            <div class="dropdown col p-0">
              <model-select v-model="lastSelectedTenantObj" :options="tenants" name="tenantLableName" id="tenantLableId"
                placeholder="Select Tenant" @input="validateSelection" class="tenantsList">
              </model-select>
            </div>
          </div>
          <div class="filterWrapper filter-wrapper-2">
            <div class="filterText">Filter:</div>
            <input v-model="filterString" type="text" maxlength="20" class="filterInputText" />
          </div>
          <!--  -->
          <div v-if="lastSelectedTenant != ''" class="importBtn" @click="addModal()" v-b-modal.modal-1>Add</div>
        </div>
      </div>

      <div class="pageDataWrapper">
        <div class="contentHeader row m-0 align-items-center">
          <div class="col-3">Name</div>
          <div class="col-2">Display Name</div>
          <div class="col-2">Set as Default</div>
          <div class="col-3">Test URL (only for testing)</div>
          <div class="col-2 actionHeading text-center">Action</div>
        </div>
        <div>
          <h3 style="margin:20px;color:#1a8088" className="table-data-info" v-if="groups.length === 0">
            No Results Found
          </h3>
        </div>
        <div class="pageData">
          <div v-for="samlGroup in groups.filter(function (x) {
            if (filterString != null && filterString.trim().length > 0) {
              return (
                (x.name && x.name.toLowerCase().indexOf(filterString.toLowerCase())) >=
                0 ||
                (x.display_name && x.display_name
                  .toLowerCase()
                  .indexOf(filterString.toLowerCase())) >= 0
              );
            }
            return true;
          })" v-bind:key="samlGroup.name" class="contentHeader row m-0 align-items-center mt-2 p-2">
            <div class="col-3">{{ samlGroup.name }}</div>
            <div class="col-2">{{ samlGroup.display_name }}</div>
            <div class="col-2">{{ getSetAsDefault(samlGroup.name) }}</div>
            <div class="col-3">{{ samlGroup.testURL }}</div>
            <div v-if="actionHide(samlGroup)" class="col-2 actionHeading text-center dropdown dropdownAction col row m-0 align-items-center">


              <a class="dropdown-toggle actionDropDown" href="javascript:void(0)" role="button" id="actionDropDownLink"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</a>
              <div class="dropdown-menu actionDropDownData dropdown-menu-left" aria-labelledby="actionDropDownLink">
                <div class="actionWrapper row m-0">
                  <div @click="setAsDefault(samlGroup)" class="actionWrapperRow row m-0 col-12">
                    <div class="col-9 actionWrapperRowHeading p-0">
                      Set as Default
                    </div>
                    <div class="col-3 p-0 text-right">
                      <div disabled="true" class="actionBtn" id="btnSendOnboarding">
                        <img src="../assets/images/edit.svg" width="16" />
                      </div>
                    </div>
                  </div>
                  <div @click="showCertificateModal(samlGroup)" class="actionWrapperRow row m-0 col-12">
                    <div class="col-9 actionWrapperRowHeading p-0">
                      Update Certificates
                    </div>
                    <div class="col-3 p-0 text-right">
                      <div disabled="true" class="actionBtn" id="btnSendOnboarding">
                        <img src="../assets/images/edit.svg" width="16" />
                      </div>
                    </div>
                  </div>
                  <div @click="deleteConnection(samlGroup)" class="actionWrapperRow row m-0 col-12">
                    <div class="col-9 actionWrapperRowHeading p-0">
                      Delete Connection
                    </div>
                    <div class="col-3 p-0 text-right">
                      <div disabled="true" class="actionBtn" id="btnSendOnboarding">
                        <img src="../assets/images/edit.svg" width="16" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="samlConnectionSetupModal" hide-backdrop centered :no-close-on-esc="true"
      v-bind:title="samlConnctionSetupTitle" title-class="test" ok-title="Next" ok-disabled
      @hidden="closeConnectionSetupModal" @cancel="closeConnectionSetupModal">
      <b-form ref="form">
        <!-- samlConnectionStep  step ===1 -->
        <b-form-group v-if="samlConnectionStep === 1">
          <label class="custom-form-label">Metadata Mode</label>
          <b-form-select id="mode_type" class="jobType" v-model="samlConnectionObj.mode" :options="samlModeArray"
            style="width: 100%">
          </b-form-select>
        </b-form-group>

        <b-form-group v-if="samlConnectionStep === 2 && samlConnectionObj.mode == 'URL'">
          <label class="custom-form-label">Metadata URL *</label>
          <b-form-input id="samlConnectionURL" type="text" v-model="samlConnectionObj.url"></b-form-input>
        </b-form-group>

        <b-form-group v-if="samlConnectionStep === 2 && samlConnectionObj.mode == 'File'">
          <label class="custom-form-label">Choose File (metadata.xml)</label>
          <div style="display:flex">
            <b-form-input disabled id="samlConnectionURL" type="text"
              v-model="samlConnectionObj.fileName"></b-form-input>
            <b-button style="float:right; margin-left: 5px;" variant="primary" title="Upload File"
              @click="uploadFile()">
              Browse
            </b-button>
          </div>
          <input type="file" hidden style="display: none" id="filesToUpload" @change="uploadMetadataFile"
            accept=".xml" />
        </b-form-group>

        <b-form-group v-if="samlConnectionStep === 3">
          <label class="custom-form-label">Name Id</label>

          <div class="row">
            <div class="col col-3 text-nowrap" style="padding-top: 5px"><b><span>{{ samlConnectionObj.nameId
                  }}</span></b>
            </div>
            <div v-if="this.checkSamlLength() > 0" class="col"><b-form-input id="samlConnectionURL" type="text"
                v-model="samlConnectionObj.nameIdPartial" @change="changeOnNameId"></b-form-input></div>
          </div>
        </b-form-group>
        <b-form-group v-if="samlConnectionStep === 3">
          <label class="custom-form-label">Entity Id</label>
          <b-form-input disabled id="samlConnectionURL" type="text" v-model="samlConnectionObj.entityId"></b-form-input>
        </b-form-group>
        <b-form-group v-if="samlConnectionStep === 3">
          <label class="custom-form-label">SSO URL</label>
          <b-form-input id="samlConnectionURL" type="text" v-model="samlConnectionObj.sso"></b-form-input>
        </b-form-group>
        <b-form-group v-if="samlConnectionStep === 3">
          <label class="custom-form-label">SLO URL</label>
          <b-form-input id="samlConnectionURL" type="text" v-model="samlConnectionObj.slo"></b-form-input>
        </b-form-group>
        <b-form-group v-if="samlConnectionStep === 3 && samlConnectionObj.mode == 'Manual'">
          <label class="custom-form-label">Choose Certificates (.cer/.crt/.pem)</label>
          <div style="display:flex">
            <b-form-input disabled id="samlConnectionURL" type="text"
              v-model="samlConnectionObj.fileName"></b-form-input>
            <b-button style="float:right; margin-left: 5px;" variant="primary" title="Upload File"
              @click="uploadManualFile()">
              Browse
            </b-button>
          </div>
          <input type="file" hidden style="display: none" id="filesManualToUpload" @change="handleFiles"
            accept=".cer,.cert,.crt,.pem" />
        </b-form-group>
        <b-form-group v-if="samlConnectionStep === 3 && samlConnectionObj.mode == 'Manual'">
          <label class="custom-form-label">Choose encryption (.cer/.crt/.pem)</label>
          <div style="display:flex">
            <b-form-input disabled id="samlConnectionURL" type="text"
              v-model="samlConnectionObj.fileNameEncrypted"></b-form-input>
            <b-button style="float:right; margin-left: 5px;" variant="primary" title="Upload File"
              @click="uploadEncryptionFile()">
              Browse
            </b-button>
          </div>
          <input type="file" hidden style="display: none" id="filesEncryptionToUpload" @change="handleEncryptedFiles"
            accept=".cer,.crt,.pem" />
        </b-form-group>
        <b-form-group v-if="samlConnectionStep === 3">
          <label class="custom-form-label">Signing Certificate</label>
          <br><b>Valid To : </b>{{ samlConnectionObj.signingCertificateValidTo }}
          <b-form-textarea disabled id="signingCertificate" type="text" v-model="samlConnectionObj.signedCertificate"
            rows="4" max-rows="3"></b-form-textarea>
        </b-form-group>
        <b-form-group v-if="samlConnectionStep === 3">
          <label class="custom-form-label">Encryption Certificate</label>
          <br><b>Valid To : </b>{{ samlConnectionObj.encryptionCertificateValidTo }}
          <b-form-textarea disabled id="encryptionCertificate" type="text"
            v-model="samlConnectionObj.encryptionCertificate" rows="4" max-rows="3"></b-form-textarea>
        </b-form-group>

      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="closeConnectionSetupModal()">
          Cancel
        </b-button>

        <b-button variant="primary" v-if="samlConnectionStep <= 2" @click="saveSamlConnection()">
          Next
        </b-button>
        <b-button v-if="samlConnectionStep === 3" :disabled="isSaveSAMLConnection()" variant="primary"
          @click="doneSamlConnection()">
          Save
        </b-button>


      </template>

    </b-modal>
    <b-modal id="updateCertificateModal" hide-backdrop centered :no-close-on-esc="true" title="Update Cerificate"
      title-class="test" ok-title="Next" ok-disabled @hidden="closeCertificateModal" @cancel="closeCertificateModal">
      <b-form ref="form">
        <b-form-group>
          <label class="custom-form-label">Choose Certificates (.cer/.crt/.pem)</label>
          <div style="display:flex">
            <b-form-input disabled type="text" v-model="certificateFileName"></b-form-input>
            <b-button style="float:right; margin-left: 5px;" variant="primary" title="Upload File"
              @click="uploadCerificateFile()">
              Browse
            </b-button>
          </div>
          <input type="file" hidden style="display: none" id="samlConnectionCertificate"
            @change="handleCertificateFiles" accept=".cer,.cert,.crt,.pem" />
        </b-form-group>
        <b-form-group>
          <label class="custom-form-label">Choose encryption (.cer/.crt/.pem)</label>
          <div style="display:flex">
            <b-form-input disabled type="text" v-model="encryptionFileName"></b-form-input>
            <b-button style="float:right; margin-left: 5px;" variant="primary" title="Upload File"
              @click="uploadEncryptedFile()">
              Browse
            </b-button>
          </div>
          <input type="file" hidden style="display: none" id="samlConnectionEncrypted"
            @change="handleUpdatedEncryptedFiles" accept=".cer,.cert,.crt,.pem" />
        </b-form-group>
        <b-form-group>
          <label class="custom-form-label">Signing Certificate</label>
          <b-form-textarea disabled id="signingCertificate" type="text" v-model="certificateFile"
            rows="4" max-rows="3"></b-form-textarea>
        </b-form-group>
        <b-form-group>
          <label class="custom-form-label">Encryption Certificate</label>
          <b-form-textarea disabled id="encryptionCertificate" type="text"
            v-model="encryptionFile" rows="4" max-rows="3"></b-form-textarea>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="closeCertificateModal()">
          Cancel
        </b-button>

        <b-button :disabled="isUploadCerficate()" variant="primary" @click="updateCerficate()">
          Upload
        </b-button>


      </template>

    </b-modal>
    <div v-if="showDeleteModal == true">
      <div class="areYouSureWrapper row m-0 align-items-center">
        <div class="popUpContent">
          <div class="popupHead">Delete Connection
            <span aria-hidden="true" class="close-button-container" @click="showDeleteModal = false">&times;</span>
          </div>
          <div class="popupBody">
            Are you sure you want to delete?
          </div>
          <div class="popupFooter">
            <div class="yesBtn btn" @click="deleteAuthConnection($event)">
              Yes
            </div>
            <div class="noBtn btn" @click="showDeleteModal = false">No</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showDefaultModal == true">
      <div class="areYouSureWrapper row m-0 align-items-center">
        <div class="popUpContent">
          <div class="popupHead">Set as Default
            <span aria-hidden="true" class="close-button-container" @click="showDefaultModal = false">&times;</span>
          </div>
          <div class="popupBody">
            Are you sure you want to set as Default?
          </div>
          <div class="popupFooter">
            <div class="yesBtn btn" @click="makeDefault($event)">
              Yes
            </div>
            <div class="noBtn btn" @click="showDefaultModal = false">No</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Vue from "vue";
import TreeView from "../components/TreeView.vue";
import Dropdown from "vue-simple-search-dropdown";
import { ModelSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
// import {parseString} from "xml2js";

export default {
  components: {
    TreeView,
    Dropdown,
    ModelSelect
  },
  data() {
    return {
      tenants: [{ text: "-SELECT ALL-", value: "*" }],
      tenantsList: [],
      lastSelectedTenant: "",
      lastSelectedTenantObj: "",
      tenantObj: null,
      filterString: "",
      groups: [],
      groupId: "",
      tenantId: "",
      locations: [],
      selectedSAMLGroup: null,
      listEmpty: false,
      samlConnctionSetupTitle: "SAML Connection",
      samlModeArray: ['URL', 'File', 'Manual'],
      samlConnectionObj: {
        mode: "URL",
        fileName: "",
        fileNameEncrypted: "",
        nameId: "",
        nameIdPartial: "",
        entityId: "",
        sso: "",
        slo: "",
        signedCertificate: "",
        signingCertificateValidTo: "",
        encryptionCertificate: "",
        encryptionCertificateValidTo: ""
      },
      samlConnectionStep: 1,
      showDeleteModal: false,
      showDefaultModal: false,
      certificateFileName: "",
      certificateFile: null,
      encryptionFileName: "",
      encryptionFile: null,
      certificateManualFile: null,
      encryptedFile: null,
      samlGroupObj: null,
      strategy:['adfs','samlp','auth0_oidc']

    };
  },
  mounted() {
    this.fetchTenants();
    $("input").attr("autocomplete", "off");

  },
  methods: {
    validateSelection() {
      this.lastSelectedTenant = this.getTenantId(this.lastSelectedTenantObj);
      this.getTeanantDetails();
      this.getGroups();
    },
    getTenantId(Obj) {
      let objVal = this.tenants.find(e => e.value == Obj);
      if (objVal) {
        return objVal.id
      }
      else {
        return ""
      }
    },
    async fetchTenants() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(
        config.TENET_SERVICE + "/tenants/?list=true",
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        }
      );
      try {
        var tenants_list = await fetch(tenants_list_request);
        if (tenants_list.status === 503) {
          // return this.fetchTenants();
        }
        var response = await tenants_list.json();
        this.tenants = response
          .map((t) => {
            return {
              text: t.text || t.value,
              id: t.value,
              value: t.value.toLowerCase().replace('-', ''),
            };
          })
          .sort((a, b) => {
            return a.text.localeCompare(b.text);
          });
        this.tenants.forEach((e) =>
          this.tenantsList.push({ id: e.value, name: e.text || e.value })
        );
      } catch (error) {
        console.error(error);
      }
    },
    addModal() {
      const randomNumber = Math.floor(Math.random() * 1000).toString(5);
      this.selectedSAMLGroup = {};
      this.samlConnectionObj = {
        mode: "URL",
        fileName: "",
        fileNameEncrypted: "",
        entityId: "",
        nameId: "",
        nameIdPartial: "",
        sso: "",
        slo: "",
        signedCertificate: "",
        signingCertificateValidTo: "",
        encryptionCertificate: "",
        encryptionCertificateValidTo: ""
      }
      this.encryptedFile = null;
      this.certificateManualFile = null;
      // this.showModal();
      this.samlConnectionStep = 1;
      // this.samlConnctionSetupTitle = tenant.fullName + ": SAML Connection";
      // this.samlConnectionObj["mode"] = this.samlModeArray[0]
      this.$bvModal.show("samlConnectionSetupModal");
    },
    async uploadFile() {
      document.getElementById("filesToUpload").click();
    },
    async uploadManualFile() {
      document.getElementById("filesManualToUpload").click();
    },
    async uploadEncryptionFile() {
      document.getElementById("filesEncryptionToUpload").click();
    },
    async uploadCerificateFile() {
      document.getElementById("samlConnectionCertificate").click();
    },
    async uploadEncryptedFile() {
      document.getElementById("samlConnectionEncrypted").click();
    },
    handleCertificateFiles(event) {
      //alert(this.importLoadingMessage);
      //Vue.$toast.open("Loading File");
      // Check for the various File API support.
      if (window.FileReader) {
        // FileReader are supported.
        //getAsText(files[0]);
        var fileToRead = event.target.files[0];
        this.certificateFileName = fileToRead.name

        var reader = new FileReader();
        // Handle errors load
        reader.onerror = (evt) => {
          if (evt.target.error.name == "NotReadableError") {
            // this.importLoadingMessage = "ERROR reading file";
            Vue.$toast.open({ message: "ERROR reading file", type: "error" });
            this.importedDeviceIds = null;

            // alert("Cannot read file !");
            Vue.$toast.open({ message: "Cannot read file !", type: "error" });
          }
        };
        reader.onload = (event) => {
          this.certificateFile = event.target.result;

        };
        // Read file into memory as UTF-8
        reader.readAsText(fileToRead);
      } else {
        // alert("FileReader are not supported in this browser.");
        Vue.$toast.open({
          message: "FileReader are not supported in this browser",
          type: "error",
        });
      }
    },
    handleUpdatedEncryptedFiles(event) {
      //alert(this.importLoadingMessage);
      //Vue.$toast.open("Loading File");
      // Check for the various File API support.
      if (window.FileReader) {
        // FileReader are supported.
        //getAsText(files[0]);
        var fileToRead = event.target.files[0];
        this.encryptionFileName = fileToRead.name

        var reader = new FileReader();
        // Handle errors load
        reader.onerror = (evt) => {
          if (evt.target.error.name == "NotReadableError") {
            // this.importLoadingMessage = "ERROR reading file";
            Vue.$toast.open({ message: "ERROR reading file", type: "error" });
            this.importedDeviceIds = null;

            // alert("Cannot read file !");
            Vue.$toast.open({ message: "Cannot read file !", type: "error" });
          }
        };
        reader.onload = (event) => {
          this.encryptionFile = event.target.result;

        };
        // Read file into memory as UTF-8
        reader.readAsText(fileToRead);
      } else {
        // alert("FileReader are not supported in this browser.");
        Vue.$toast.open({
          message: "FileReader are not supported in this browser",
          type: "error",
        });
      }
    },
    async uploadMetadataFile(event) {
      if (window.FileReader) {
        const filesToRead = event.target.files;
        if (filesToRead && filesToRead.length > 0) {
          const fileToRead = filesToRead[0];
          let fileReader = new FileReader();
          fileReader.onerror = (event) => {
            if (evt.target.error.name == "NotReadableError") {
              Vue.$toast.open({ message: "Cannot load the Metadata XML file", type: "error" });
            }
          }
          fileReader.onload = async (event) => {
            try {
              const metadataEncoded = Buffer.from(event.target.result).toString("base64");

              await this.getMetadataFromURL("", metadataEncoded);
            } catch (error) {
              Vue.$toast.open({
                message: "Failed to parse the Metadata from the file. Please download the file and use as is without any changes to the file.",
                type: "error",
                duration: 10000
              });
              return false;
            }
          }
          fileReader.readAsText(fileToRead);
        }
      }
    },
    handleFiles(event) {
      //alert(this.importLoadingMessage);
      //Vue.$toast.open("Loading File");
      // Check for the various File API support.
      if (window.FileReader) {
        // FileReader are supported.
        //getAsText(files[0]);
        var fileToRead = event.target.files[0];
        this.samlConnectionObj.fileName = fileToRead.name
        var reader = new FileReader();
        // Handle errors load
        reader.onerror = (evt) => {
          if (evt.target.error.name == "NotReadableError") {
            // this.importLoadingMessage = "ERROR reading file";
            Vue.$toast.open({ message: "ERROR reading file", type: "error" });
            this.importedDeviceIds = null;

            // alert("Cannot read file !");
            Vue.$toast.open({ message: "Cannot read file !", type: "error" });
          }
        };
        reader.onload = (event) => {
          this.certificateManualFile = event.target.result;
          this.samlConnectionObj.signedCertificate = event.target.result;
        };
        // Read file into memory as UTF-8
        reader.readAsText(fileToRead);
      } else {
        // alert("FileReader are not supported in this browser.");
        Vue.$toast.open({
          message: "FileReader are not supported in this browser",
          type: "error",
        });
      }
    },
    handleEncryptedFiles(event) {
      //alert(this.importLoadingMessage);
      //Vue.$toast.open("Loading File");
      // Check for the various File API support.
      if (window.FileReader) {
        // FileReader are supported.
        //getAsText(files[0]);
        var fileToRead = event.target.files[0];
        this.samlConnectionObj.fileNameEncrypted = fileToRead.name
        var reader = new FileReader();
        // Handle errors load
        reader.onerror = (evt) => {
          if (evt.target.error.name == "NotReadableError") {
            // this.importLoadingMessage = "ERROR reading file";
            Vue.$toast.open({ message: "ERROR reading file", type: "error" });
            this.importedDeviceIds = null;

            // alert("Cannot read file !");
            Vue.$toast.open({ message: "Cannot read file !", type: "error" });
          }
        };
        reader.onload = (event) => {
          // var csv = event.target.result;
          this.encryptedFile = event.target.result;
          this.samlConnectionObj.encryptionCertificate = event.target.result;

        };
        // Read file into memory as UTF-8
        reader.readAsText(fileToRead);
      } else {
        // alert("FileReader are not supported in this browser.");
        Vue.$toast.open({
          message: "FileReader are not supported in this browser",
          type: "error",
        });
      }
    },
    closeConnectionSetupModal() {
      this.$bvModal.hide("samlConnectionSetupModal");
      this.samlConnectionObj = {
        mode: "Manual",
        fileName: "",
        fileNameEncrypted: ""
      };//clearing the selection/added details after closing the model
    },
    async changeOnNameId() {
      this.samlConnectionObj["entityId"] = `urn:${config.AUTH0_ENTITY_ID}:${this.lastSelectedTenant}:${this.samlConnectionObj["nameId"]}${this.samlConnectionObj.nameIdPartial}`;
    },
    async saveSamlConnection() {
      if (this.samlConnectionStep === 1) {
        if (this.samlConnectionObj && this.samlConnectionObj.mode === "URL") {
          this.samlConnectionStep = 2;
          this.samlConnctionSetupTitle = "SAML Connection - Enter Metadata URL"
          this.samlConnectionObj.nameIdPartial = moment(new Date()).format("MMDDYYYY");
          if (this.checkSamlLength() === 0)
            this.samlConnectionObj["nameId"] = `${this.lastSelectedTenant}-saml`
          else
            this.samlConnectionObj["nameId"] = `${this.lastSelectedTenant}-saml-`
          this.samlConnectionObj["entityId"] = `urn:${config.AUTH0_ENTITY_ID}:${this.lastSelectedTenant}:${this.samlConnectionObj["nameId"]}${this.samlConnectionObj.nameIdPartial}`;
        } else if (this.samlConnectionObj && this.samlConnectionObj.mode === "File") {
          this.samlConnectionStep = 2;
          this.samlConnctionSetupTitle = "SAML Connection - Select Metadata File";
          this.samlConnectionObj.nameIdPartial = moment(new Date()).format("MMDDYYYY");
          if (this.checkSamlLength() === 0)
            this.samlConnectionObj["nameId"] = `${this.lastSelectedTenant}-saml`
          else
            this.samlConnectionObj["nameId"] = `${this.lastSelectedTenant}-saml-`
          this.samlConnectionObj["entityId"] = `urn:${config.AUTH0_ENTITY_ID}:${this.lastSelectedTenant}:${this.samlConnectionObj["nameId"]}${this.samlConnectionObj.nameIdPartial}`;
        } else if (this.samlConnectionObj && this.samlConnectionObj.mode === "Manual") {
          this.samlConnectionStep = 3;
          this.samlConnctionSetupTitle = "SAML Connection - Enter Metadata information"
          this.samlConnectionObj.nameIdPartial = moment(new Date()).format("MMDDYYYY");
          if (this.checkSamlLength() === 0)
            this.samlConnectionObj["nameId"] = `${this.lastSelectedTenant}-saml`
          else
            this.samlConnectionObj["nameId"] = `${this.lastSelectedTenant}-saml-`
          this.samlConnectionObj["entityId"] = `urn:${config.AUTH0_ENTITY_ID}:${this.lastSelectedTenant}:${this.samlConnectionObj["nameId"]}${this.samlConnectionObj.nameIdPartial}`;
        }
      } else if (this.samlConnectionStep === 2) {
        if (this.samlConnectionObj && this.samlConnectionObj.mode === "URL") {
          await this.getMetadataFromURL(this.samlConnectionObj.url);
        } else if (this.samlConnectionObj && this.samlConnectionObj.mode === "File") {
          this.samlConnectionStep = 3;
          this.samlConnctionSetupTitle = "SAML Connection - Confirm data is accurate";
        }
      }
    },
    async getMetadataFromURL(metadataURL = "", encodeMetaDataAsString = "") {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url = config.OPERATIONS_SERVICE + "/parse-saml-metadata";
      var metaDataRequest = new Request(url, {
        method: "POST",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        body: JSON.stringify({
          ...(metadataURL && { url: metadataURL }),
          ...(encodeMetaDataAsString && { encodeMetaDataAsString: encodeMetaDataAsString })
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        const metadataResponse = await fetch(metaDataRequest);
        if (!metadataResponse.ok) {

        }
        if (metadataResponse.status === 503) {
          this.getMetadataFromURL(metadataURL, metaDateXMLInBase64);
        }
        try {
          const metadataResponseJSON = await metadataResponse.json();
          if (metadataResponseJSON) {
            if (metadataResponseJSON.idpCertificates && metadataResponseJSON.idpCertificates.signing && metadataResponseJSON.idpCertificates.signing.length > 0) {
              metadataResponseJSON.idpCertificates.signing.forEach((certificate) => {
                certificate["certificate"] = Buffer.from(certificate["encodedCertificate"], "base64").toString("binary");
                certificate["validToDT"] = certificate["validToDT"] && new Date(certificate["validToDT"]);
              })

              metadataResponseJSON.idpCertificates.signing.sort((a, b) => {
                return a.validToDT - b.validToDT;
              });

              this.samlConnectionObj.signedCertificate = metadataResponseJSON.idpCertificates.signing[0].certificate;
              this.samlConnectionObj.signingCertificateValidTo = metadataResponseJSON.idpCertificates.signing[0].validTo;
            }

            if (metadataResponseJSON.idpCertificates && metadataResponseJSON.idpCertificates.encryption && metadataResponseJSON.idpCertificates.encryption.length > 0) {
              metadataResponseJSON.idpCertificates.encryption.forEach((certificate) => {
                certificate["certificate"] = Buffer.from(certificate["encodedCertificate"], "base64").toString("binary");
                certificate["validToDT"] = certificate["validToDT"] && new Date(certificate["validToDT"]);
              })

              metadataResponseJSON.idpCertificates.encryption.sort((a, b) => {
                return a.validToDT - b.validToDT;
              });

              this.samlConnectionObj.encryptionCertificate = metadataResponseJSON.idpCertificates.encryption[0].certificate;
              this.samlConnectionObj.encryptionCertificateValidTo = metadataResponseJSON.idpCertificates.encryption[0].validTo;
            }

            this.samlConnectionObj.sso = metadataResponseJSON.targetSSOUrl;
            this.samlConnectionObj.slo = metadataResponseJSON.targetSLOUrl;

            if (!this.samlConnectionObj.sso || !this.samlConnectionObj.signedCertificate) {
              Vue.$toast.open({
                message: "Failed to get SSO URL OR signed certificate from the Metadata. This is required.",
                type: "error",
                timeout: 15000
              });
              return false;
            }

            this.samlConnectionStep = 3;
            this.samlConnctionSetupTitle = "SAML Connection - Confirm data is accurate";
            return true;
          }
        } catch (err) {
          Vue.$toast.open({
            message: "Failed to parse SAML metadata. Please download the Metadata file and upload as a File.",
            type: "error",
            duration: 10000
          });
          return false;
        }

      } catch (error) {
        Vue.$toast.open({
          message: "Failed to download the metadata from URL. Please download the Metadata file and upload as a File.",
          type: "error",
          duration: 10000
        });
        return false;
      }
      return false;
    },
    uploadMetadataFromFile() {

    },
    isSaveSAMLConnection() {
      if (this.samlConnectionObj.entityId != ""
        && this.samlConnectionObj.sso != ""
        && this.samlConnectionObj.signedCertificate != "")
        return false;
      else
        return true;
    },
    isUploadCerficate() {
      if (this.certificateFile) {
        return false;
      }
      else {
        return true;
      }

    },
    async doneSamlConnection() {
      await this.createSamlConnection();
      await this.getGroups();
    },
    checkSamlLength() {
      const result = this.groups.filter(item => item.name.includes("-saml"));
      return result.length
    },
    closeModal() {
      this.getGroups();
      this.selectedSAMLGroup = {};
      this.modalShow = false;
    },
    showModal() {
      this.modalShow = true;
    },
    async onEditChanged(samlGroup) {
      this.selectedSAMLGroup = samlGroup;
      this.showModal();
    },
    json2array(json) {
      var result = [];
      var keys = Object.keys(json);
      keys.forEach(function (key) {
        var arrObj = {};
        arrObj["name"] = key;
        for (var keyEle in json[key]) {
          arrObj[keyEle] = json[key][keyEle];
        }
        result.push(arrObj);
      });
      return result;
    },
    async getGroups() {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      this.listEmpty = false;
      // this.groups = [];
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.OPERATIONS_SERVICE +
        `/tenants/${this.lastSelectedTenant}/auth0-connection`;
      var saml_Groups = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var response = await fetch(saml_Groups);
        if (response.status === 503) {
          return this.getGroups();
        }
        if (response.status === 403) {
          console.log("response", response)
          Vue.$toast.open({
            message: "Access Denied",
            type: "error",
          });
          loader.hide();
          return true;
        }
        var groups_saml = await response.json();
        if (groups_saml && groups_saml.length > 0) {
          groups_saml.forEach((group) => {
            group["testURL"] = `https://${this.lastSelectedTenant}.care.ai/?scope=${group.name}`;
          })
        }
        this.groups = groups_saml;
        if (this.groups.length == 0) {

          this.listEmpty = true;
        } else if (this.groups.length > 0) {
          this.listEmpty = false;
        }
        loader.hide();
      } catch (error) {
        console.error(error);
        loader.hide();

      }
    },
    showCertificateModal(samlGroup) {
      this.samlGroupObj = samlGroup;
      this.certificateFile = null;
      this.certificateFileName = "";
      this.$bvModal.show("updateCertificateModal");
    },
    setAsDefault(samlGroup) {
      this.samlGroupObj = samlGroup;
      this.showDefaultModal = true;
    },
    deleteConnection(samlGroup) {
      this.samlGroupObj = samlGroup;
      this.showDeleteModal = true
    },
    closeCertificateModal() {
      this.$bvModal.hide("updateCertificateModal");
    },
    async updateCerficate() {
      debugger
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      const formData = new FormData();
      formData.append("connectionId", this.samlGroupObj.id);
      formData.append("name", this.samlGroupObj.name);
      // formData.append("certificate", this.certificateFile);
      formData.append("x509Certificate", this.certificateFile);
      formData.append("encryptionCertificate", this.certificateFile);
      formData.append("entityId", this.samlGroupObj.options ? this.samlGroupObj.options.entityId : "");
      formData.append("signInEndpoint", this.samlGroupObj.options ? this.samlGroupObj.options.signInEndpoint : "");
      // formData.append("ssoUrl", this.samlGroupObj.options.signInEndpoint);
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.OPERATIONS_SERVICE +
        `/tenants/${this.lastSelectedTenant}/auth0-connection`;
      var saml_Groups = new Request(url, {
        method: "PATCH",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        body: formData,
        headers: {
          Authorization: "Bearer " + id_token
        },
      });
      try {
        var response = await fetch(saml_Groups);
        if (response.status === 403) {
          console.log("response", response)
          Vue.$toast.open({
            message: "Access Denied",
            type: "error",
          });
          loader.hide();
          return true;
        }

        if (response.status === 200) {
          Vue.$toast.open({
            message: "Uploaded Certificate Successfully",
            type: "success",
          });
        }
        else {
          Vue.$toast.open({
            message: "Failed",
            type: "error",
          });
        }

        loader.hide();


      } catch (error) {
        console.error(error);
      }


      this.closeCertificateModal();
    },
    async createSamlConnection() {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      const formData = new FormData();
      if (this.checkSamlLength() === 0)
        formData.append("nameId", this.samlConnectionObj.nameId);
      else
        formData.append("nameId", this.samlConnectionObj.nameId + this.samlConnectionObj.nameIdPartial);
      formData.append("entityID", this.samlConnectionObj.entityId);
      formData.append("ssoUrl", this.samlConnectionObj.sso);
      formData.append("sloUrl", this.samlConnectionObj.slo);
      formData.append("x509Certificate", this.samlConnectionObj.signedCertificate);
      formData.append("encryptionCertificate", this.samlConnectionObj.encryptionCertificate);
      var url =
        config.OPERATIONS_SERVICE +
        `/tenants/${this.lastSelectedTenant}/auth0-connection`;
      var saml_Groups = new Request(url, {
        method: "POST",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        body: formData,
        headers: {
          Authorization: "Bearer " + id_token
        },
      });
      try {
        var response = await fetch(saml_Groups);

        if (response.status === 403) {
          Vue.$toast.open({
            message: "Access Denied",
            type: "error",
          });
          loader.hide();
          return true;
        }

        if (response.status === 200) {
          var resultObj = await response.json();
          if (resultObj.data) {
            this.groups.push(resultObj.data)
          }
          Vue.$toast.open({
            message: "SAML Connection Created Sucessfully",
            type: "success",
          });

          this.$bvModal.hide("samlConnectionSetupModal");
        }
        else {
          var resultObj = await response.json();
          let errorMessage = "Creating SAML connection failed."
          if (resultObj && resultObj.error) {
            errorMessage = resultObj.error;
          }
          Vue.$toast.open({
            message: errorMessage,
            type: "error",
          });
        }
        loader.hide();
      } catch (error) {
        console.error(error);
      }

    },
    async deleteAuthConnection() {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.OPERATIONS_SERVICE +
        `/tenants/${this.lastSelectedTenant}/auth0-connection/connection/${this.samlGroupObj.id}`;
      var saml_Groups = new Request(url, {
        method: "DELETE",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var response = await fetch(saml_Groups);

        if (response.status === 403) {
          console.log("response", response)
          Vue.$toast.open({
            message: "Access Denied",
            type: "error",
          });
          loader.hide();
          return true;
        }

        if (response.status === 200) {
          var findIndex = this.groups.findIndex((s) => s.id === this.samlGroupObj.id);
          if (findIndex !== -1) {
            this.groups.splice(findIndex, 1);
          }
          Vue.$toast.open({
            message: "Deleted Successfully",
            type: "success",
          });
        }
        else {
          Vue.$toast.open({
            message: "Failed",
            type: "error",
          });
        }

        this.showDeleteModal = false;
        loader.hide();
      } catch (error) {
        console.error(error);
      }

    },
    actionHide(data){
      if(this.strategy.includes(data.strategy)){
        return true
      }
      else{
        return false;
      }
    },
    getSetAsDefault(connectionName) {
      if (this.tenantObj && this.tenantObj.routes) {
        let keyName = "https://" + this.lastSelectedTenant + ".care.ai";
        let findDefault = this.tenantObj.routes.find(e => e.key === keyName && e.connectionId === connectionName && e.type === "ROUTES_URL")
        if (findDefault)
          return "TRUE"
        else
          return "FALSE"
      }
      else {
        return "FALSE";
      }
    },
    async makeDefault() {
      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.TENET_SERVICE +
        `/tenants/${this.lastSelectedTenant}/auth0/connections/${this.samlGroupObj.name}/set-default`;
      var saml_Groups = new Request(url, {
        method: "PATCH",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var response = await fetch(saml_Groups);

        if (response.status === 403) {
          console.log("response", response)
          Vue.$toast.open({
            message: "Access Denied",
            type: "error",
          });
          loader.hide();
          return true;
        }

        if (response.status === 200) {

          let keyName = "https://" + this.lastSelectedTenant + ".care.ai";
          let findDefault = this.tenantObj.routes.find(e => e.key === keyName && e.type === "ROUTES_URL");
          if (findDefault) {
            findDefault.connectionId = this.samlGroupObj.name
          }
          Vue.$toast.open({
            message: "Set as Default Successfully",
            type: "success",
          });
        }
        else {
          Vue.$toast.open({
            message: "Failed",
            type: "error",
          });
        }

        this.showDefaultModal = false;
        loader.hide();
      } catch (error) {
        console.error(error);
      }

    },
    async getTeanantDetails() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.TENET_SERVICE +
        `/tenants/${this.lastSelectedTenant}`;
      var tenant_req = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var response = await fetch(tenant_req);

        if (response.status === 403) {
          console.log("response", response)
          Vue.$toast.open({
            message: "Access Denied",
            type: "error",
          });
          loader.hide();
          return true;
        }
        var resultObj = await response.json();
        if (response.status === 200) {
          this.tenantObj = resultObj;
        }
        else {

        }
      } catch (error) {
        console.error(error);
      }

    }

  },
};
</script>
<style lang="scss">
.pageHeader {
  height: 56px;
  color: #fff;
  background: #484848;
  font-size: 15px;
  padding: 0 15px;
}

.ui.selection.dropdown {
  border: none !important;

  i.dropdown.icon {
    display: none;
  }
}

.pageHeader {
  font-size: 20px;
}

.pageHeaderTitle {
  padding-left: 15px !important;
}

.filterWrapper {
  background: #575757;
  display: inline-flex;
  padding: 0px 15px;
  font-size: 15px;
  min-width: 360px;
  max-width: 360px;
  border-radius: 5px;
  margin-left: 10px;
  align-items: center;
  text-overflow: ellipsis;
}

.pageHeader .filterWrapper .dropdown:before {
  border: solid #fff;
  border-width: 0 1px 1px 0;
}


.filterWrapper .dropdown:before {
  content: "";
  border: solid #8e8e8e;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 0px;
  top: 15px;
}

.filter-wrapper-2 {
  max-width: 400px;
  min-height: 36px;
}

.filterText {
  color: #fff;
  opacity: 1;
  padding-right: 5px;
}

.filterWrapper .dropdown {
  width: 100%;
  text-align: left;
  cursor: pointer;
  background: transparent !important;
  height: auto;
}

.filterInputText {
  max-width: 215px !important;
  background: #575757 !important;
  outline: none !important;
  border: 1px solid #575757 !important;
  color: #fff !important;
  padding: 1px 15px;
}

.pageHeader .importBtn {
  background: #575757;
}

.pageHeader .importBtn:hover {
  background: #1dd8f6;
}

.importBtn {
  background: #1dd8f6;
  display: inline-flex;
  padding: 0px 10px;
  font-size: 16px;
  border-radius: 5px;
  margin-left: 10px;
  width: auto;
  line-height: 36px;
}

.importBtn:hover {
  color: #fff;
  cursor: pointer;
  background: #3288D2;
}

.contentHeader {
  background: #ebebeb;
  height: 42px;
  color: #484848;
  border-radius: 5px;
}

.pageData .contentHeader {
  height: auto;
  background: #fff;
  border: 1px solid #ebebeb;
  color: #6a6a6a;
}

.pageData .contentHeader:hover {
  background: #f2fdff;
  cursor: pointer;
}

.contentHeader>div.actionHeading {
  justify-content: center !important;
}

.pageDataWrapper {
  padding: 15px;
}


.requestCol-saml {
  background-color: white;
  padding: 15px;
  display: flex;
  flex-direction: column;
}

.requestCol-saml textarea,
.requestCol-saml textarea:focus {
  border: 1px solid #ebebeb;
  box-shadow: none;
  max-width: 100%;
  color: #6a6a6a;
}

.requestCol-saml select,
.requestCol-saml select:focus {
  border: 1px solid black;
  background-color: #eee;
  max-width: 35rem;
}

#access-search {
  border: 1px solid black;
  border-bottom: 0;
  box-shadow: none;
}

.requestCol-saml select {
  max-width: 35rem;
}

#modal-1 .requestCol-saml,
#modal-1 .previewCol {
  border-radius: 5px;
  min-height: 50vh;
  border: 1px solid #ebebeb;
}

#modal-1 .modal-body {
  padding: 0px
}

#modal-1 .requestCol-saml h6 {
  color: #3288D2;
}

.tenantOption {
  color: #6a6a6a;
  padding: 10px;
}

#collapsible-list {
  border: 1px solid black;
  height: 400px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

#collapsible-list p {
  margin: 0;
}

.collapsible-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ci-icon-container {
  display: flex;
  align-items: center;
}

.ci-icon {
  font-size: 2rem;
  background-color: white;
  color: white;
}

.ci-checkboxes {
  display: flex;
}

.ci-checkbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ci-checkbox p {
  margin: 0 0.5rem !important;
}

.collapsible-stuff {
  width: 90%;
  float: right;
}

#collapsible-stuff1 {
  margin-left: 2rem;
}

.collapsible-item-container ul {
  margin: 0;
}

#access-container .col {
  margin: 0 !important;
  padding: 0 !important;
}

.facilitiesWrapper {
  max-height: 275px;
  min-height: 275px;
}

.facilityDetails {
  display: flex;
}

.headerpart {
  color: #484848;
  overflow: hidden;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #dae1f2;
  padding: 0 0;
  display: flex;
}

.facilitiesList {
  padding-top: 5px;
  overflow: hidden;
  padding-bottom: 5px;
  cursor: pointer;
  display: flex;
}

.facilitiesList {
  height: 36px;
  align-items: center;
}

.facilityListWrap.facilityListWrapLeft {
  max-height: 334px;
}

.facilityListWrap {
  max-height: 325px;
  overflow: hidden;
  overflow-y: auto;
}

.pull-left {
  float: left;
}

.treeWrapper.facilityTreeWrapper {
  max-height: 364px;
}

.treeWrapper,
.facilityListWrap {
  max-height: 245px;
  overflow: hidden;
  overflow-y: auto;
}

.treeWrapper {
  margin: 5px 0 5px 20px;
}

.facilityListName {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.actionDropDown {
  background: #1dd8f6 !important;
  border-radius: 5px;
  color: #fff !important;
  float: left;
  padding: 5px 25px;
  text-align: left;
  width: auto !important;
  padding: 0 30px 0 20px !important;
  height: 40px !important;
  line-height: 40px;
  position: relative;
}

.actionDropDown:after {
  position: absolute;
  top: 18px;
  right: 15px;
}

.actionDropDown:hover {
  text-decoration: none;
}

.actionDropDownData {
  padding: 0;
  border-radius: 0;
  top: 21px !important;
  border: 1px solid #e5f0f2;
}

.actionDropDownData {
  top: 10px !important;
  min-width: 300px !important;
  background: #fff !important;
  border-radius: 5px !important;
  max-width: 300px !important;
  border: 0px solid #e5f0f2;
  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
}

.actionDropDownData>a:last-child::after,
.actionDropDownData>a.active::after,
.actionDropDownData>a:hover:after {
  display: none;
}

.actionWrapperRow {
  padding-bottom: 5px;
  margin-bottom: 5px !important;
  border-bottom: 1px solid #dceaea;
}

.actionWrapperRow:last-child {
  padding-bottom: 0;
  margin-bottom: 0 !important;
  border-bottom: 0px solid;
}

.actionWrapperRow .actionWrapperRowHeading {
  color: #808f96;
  font-size: 15px;
  font-family: GTWalsheimPro-Regular;
  letter-spacing: 0px;
  opacity: 1;
}
</style>
<style lang="scss" scoped>
::v-deep .ui.search.dropdown .text {
  max-width: 230px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #fff;
  top: 2px;
}

::v-deep .ui.selection.dropdown .menu .item {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  // max-width: 334px;
  margin: 0px 10px 2px;
  padding: 10px 7px !important;
  border-radius: 5px;
  border: none;
}

.pageHeader ::v-deep .ui.default.dropdown:not(.button)>input:focus~.text,
.pageHeader ::v-deep .ui.dropdown:not(.button)>input:focus~.default.text,
.pageHeader ::v-deep .ui.active.search.dropdown input.search:focus+.text {
  color: #fff !important;
}

::v-deep .ui.selection.active.dropdown .menu {
  border: 1px solid #EBEBEB;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, .15);
  padding: 10px 0;
  margin-top: 1px;
  border-top-width: 1px !important;
}


::v-deep .ui.selection.active.dropdown:hover,
::v-deep .ui.selection.active.dropdown {
  box-shadow: none;
}

::v-deep .ui.dropdown .menu>.item:hover {
  color: #1dd8f6;
  background: #EAF9FF !important;
}

::v-deep .ui.dropdown .menu>.item.selected {
  color: #1dd8f6;
  background: #fff;
}

::v-deep #modal-1 .modal-dialog {
  max-width: 850px;
}

.table-data-info {}



.areYouSureWrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  background: rgba(0, 0, 0, 0.2);
}

.popUpContent {
  min-width: 350px;
  max-width: 350px;
  border-radius: 10px;
  background: #fff;
}

.popupHead {
  background: #f7f7f7;
  line-height: 40px;
  border-radius: 10px 10px 0 0;
  // color: #fff;
  padding: 0 15px;
  height: 40px;
}

.popupHead span {
  float: right;
  cursor: pointer;
}

.popupBody {
  color: #6a6a6a;
  padding: 15px;
}

.filterWrapper .dropdown:before {
  content: "";
  border: solid #8e8e8e;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 0px;
  top: 15px;
}

.popupFooter {
  border-radius: 0px 0px 10px 10px;
  background: #fff;
  color: #6a6a6a;
  padding: 15px;
  justify-content: center;
  text-align: center;
  border-top: 1px solid #ebebeb;
}

.yesBtn,
.noBtn {
  margin-right: 10px;

  border-radius: 5px;
  padding: 5px 20px !important;
}

.yesBtn {
  background: #66BE6D;
  border: 1px solid #66BE6D;
}

.noBtn {
  margin-left: 0;
  margin-right: 0px;
  background: #F27778;
  border: 1px solid #F27778;
}

.yesBtn:hover {
  background: #3FAA48 !important;
  border: 1px solid #3FAA48 !important;
}

.noBtn:hover {
  background: #E62829 !important;
  border: 1px solid #E62829 !important;
}
</style>
